import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.4141 5.00003L9.41406 12L16.4141 19L14.9998 20.4142L6.58564 12L14.9998 3.58582L16.4141 5.00003Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgChevronLeft);
export default ForwardRef;
